import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Teleconsent = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <path
        d='M21 18s-1.334 1.545-2.834 1.545-2.707-1.43-4.18-1.43-2.395.804-2.986 1.43m7.414-15.13.172.171a2 2 0 0 1 0 2.828l-12 12A2 2 0 0 1 5.172 20H3v-2.17a2 2 0 0 1 .586-1.415l12-12a2 2 0 0 1 2.828 0'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    ) : (
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M15.056 3.884a2.75 2.75 0 0 1 3.889 0l.171.172a2.75 2.75 0 0 1 0 3.889l-12 12a2.75 2.75 0 0 1-1.944.805H3a.75.75 0 0 1-.75-.75v-2.17c0-.73.29-1.43.805-1.945zm5.377 13.626a.75.75 0 0 1 1.135.98L21 18l.568.49-.002.002-.002.002-.005.006-.016.018a5 5 0 0 1-.251.26 7 7 0 0 1-.7.597c-.566.42-1.435.92-2.426.92-.942 0-1.765-.438-2.398-.774l-.054-.029c-.71-.377-1.211-.627-1.727-.627-1.16 0-1.898.62-2.442 1.195a.75.75 0 0 1-1.09-1.03c.638-.675 1.746-1.665 3.532-1.665.922 0 1.736.433 2.362.766l.069.036c.706.375 1.217.628 1.748.628.509 0 1.057-.272 1.533-.625a5.4 5.4 0 0 0 .727-.653z'
        fill='currentColor'
      />
    )}
  </IconBase>
);
